export default __webpack_public_path__ + "static/media/brochure.c074e0d6.pdf";